export default "__VITE_ASSET__CcyG9hQJ__"